<template>
    <div
        class="group relative h-full overflow-hidden rounded-12 bg-[#FFFFFF0D] p-3">
        <div class="absolute inset-0 z-0 size-full">
            <div class="bg-noise"></div>
        </div>
        <div class="relative flex h-full flex-col">
            <div class="max-h-full w-full shrink-0 overflow-hidden rounded-12">
                <picture
                    class="size-full object-cover transition-all duration-500 md:group-hover:scale-110">
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/ui/placeholder/webp/cromi.webp
                        " />

                    <img
                        loading="lazy"
                        alt="Логотип Cromi"
                        src="/assets/images/ui/placeholder/jpg-png/cromi.png"
                        class="object-cover transition-all duration-500 max-md:h-full max-md:max-h-[150px] max-md:w-full md:group-hover:scale-110" />
                </picture>
            </div>
            <div class="mt-5 flex h-full flex-col items-center justify-center">
                <h3
                    class="text-20/120 font-semibold text-ash-200 lg:text-24/133">
                    Еще больше о Cromi
                </h3>
                <BaseLink
                    :to="cardInfo?.url"
                    target="_blank"
                    icon-right="arrow-right"
                    class="my-7">
                    {{ cardInfo?.text }}
                </BaseLink>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseLink from '~/components/base/base-link/BaseLink.vue'

const props = defineProps({
    specialType: {
        type: String as PropType<'media' | 'portfolio' | 'news' | 'article'>,
        required: true,
    },
})

const cardInfo = computed(() => {
    const infoTypes = [
        {
            text: 'О нас в СМИ',
            type: 'media',
            url: '/media',
        },
        {
            text: 'В портфолио',
            type: 'portfolio',
            url: '/portfolio',
        },
        {
            text: 'Все новости',
            type: 'news',
            url: '/news',
        },
        {
            text: 'Все статьи',
            type: 'article',
            url: '/pro',
        },
    ]

    return infoTypes.find((infoType) => infoType.type === props.specialType)
})
</script>
